import {
  WAITLIST_SUBSCRIBE_PENDING,
  WAITLIST_SUBSCRIBE_FULFILLED,
  WAITLIST_SUBSCRIBE_REJECTED,
  WAITLIST_TOGGLE_FORM_VISIBILITY,
} from '../actions';

const initialState = {};

const waitlist = (state = initialState, action) => {
  switch (action.type) {
    case WAITLIST_SUBSCRIBE_PENDING:
      return {
        ...state,
        [action.meta.sliceId]: {
          ...state[action.meta.sliceId],
          busy: true,
          error: undefined,
          success: false,
        },
      };
    case WAITLIST_SUBSCRIBE_FULFILLED:
      return {
        ...state,
        [action.meta.sliceId]: {
          ...state[action.meta.sliceId],
          busy: false,
          error: undefined,
          data: action.payload,
          success: true,
        },
      };
    case WAITLIST_SUBSCRIBE_REJECTED:
      return {
        ...state,
        [action.meta.sliceId]: {
          ...state[action.meta.sliceId],
          busy: false,
          error: action.payload.message,
          success: false,
        },
      };
    case WAITLIST_TOGGLE_FORM_VISIBILITY:
      return {
        ...state,
        [action.meta.sliceId]: {
          ...state[action.meta.sliceId],
          visible: state[action.meta.sliceId] ? !state[action.meta.sliceId].visible : true,
        },
      };
    default:
      return state;
  }
};

export default waitlist;
